import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'
import md5 from 'js-md5'

export function getCustomerUsers(myPage) {
  return request({
    url: cmsServerContext + '/customerUser/list',
    method: 'post',
    data: myPage
  })
}

export function saveCustomerUser(customerUser) {
  const temp = Object.assign({}, customerUser)
  if (typeof temp.password !== 'undefined' && temp.password !== null && temp.password !== '') {
    temp.password = md5(md5(temp.password) + temp.password)
  }
  return request({
    url: cmsServerContext + '/customerUser/save',
    method: 'post',
    data: temp
  })
}
export function queryCustomerById(id) {
  return request({
    url: cmsServerContext + '/customerUser/queryCustomerById/' + id,
    method: 'get'
  })
}

/**
 * 更新客户用户本身的信息，不包括关联信息
 * Add by xingxiaowen on 2018/10/15
 * @param customerUser
 */
export function updateCustomerUserSimp(customerUser) {
  const temp = Object.assign({}, customerUser)
  if (typeof temp.password !== 'undefined' && temp.password !== null && temp.password !== '') {
    temp.password = md5(md5(temp.password) + temp.password)
  }
  return request({
    url: cmsServerContext + '/customerUser/updateSimp',
    method: 'post',
    data: temp
  })
}
/**
 * @author wanghui
 * @date 2018/12/21 17:08
 * @param
 * 修改用户信息
 */
export function updateCustomerUser(customerUser) {
  const temp = Object.assign({}, customerUser)
  if (typeof temp.password !== 'undefined' && temp.password !== null && temp.password !== '') {
    temp.password = md5(md5(temp.password) + temp.password)
  }
  return request({
    url: cmsServerContext + '/customerUser/updateCustomerUser',
    method: 'post',
    data: temp
  })
}
/**
 * 用户账号唯一性校验, 账号必填，编辑的需要加上id
 * Add by xingxiaowen on 2018/10/15
 * @param customerUser
 */
export function verifyCustomerUser(customerUser) {
  return request({
    url: cmsServerContext + '/customerUser/verify',
    method: 'post',
    data: customerUser
  })
}

export function checkCustomerByIdAndPwd(id, pwd) {
  //  pwd = md5(md5(pwd) + pwd)
  // alert(pwd)
  return request({
    url: cmsServerContext + '/customerUser/checkCustomerByIdAndPwd?id=' + id + '&password=' + pwd,
    method: 'get'
  })
}
/**
   * @author wanghui
   * @date 2018/10/30 13:09
   * @param
   * @return
   * 根据能耗单元ids查询业主用户
   */
export function queryCustomerByEnergyUnitIds(ids) {
  return request({
    url: cmsServerContext + '/customerUser/selectCustomerUserByEnergyUnitIds/' + ids,
    method: 'get'
  })
}

/**
 * @author wanghui
 * @date 2018/11/01 13:09
 * @param
 * @return
 * 根据用户ids查询业主用户
 */
export function queryCustomerByIds(ids) {
  return request({
    url: cmsServerContext + '/customerUser/selectCustomerUserByIds/' + ids,
    method: 'get'
  })
}

/**
 * 删除业主用户
 * create by liangxingming on 20181025
 * @param customerUser
 * */
export function deleteCustomerUser(customerUser) {
  return request({
    url: cmsServerContext + '/customerUser/delete',
    method: 'post',
    data: customerUser
  })
}

/**
 * 批量保存业主用户
 * create by liangxingming on 20181027
 * @param customerUser
 * */
export function saveBatchTenant(customerUserArr) {
  for (var i = 0; i < customerUserArr.length; i++) {
    const customerUser = customerUserArr[i]
    if (typeof customerUser.password !== 'undefined' && customerUser.password !== null && customerUser.password !== '') {
      customerUser.password = md5(md5(customerUser.password) + customerUser.password)
    }
  }
  return request({
    url: cmsServerContext + '/customerUser/saveBatchTenant',
    method: 'post',
    data: customerUserArr
  })
}

export function verifyBatchTenant(customerUserArr) {
  return request({
    url: cmsServerContext + '/customerUser/verifyBatch',
    method: 'post',
    data: customerUserArr
  })
}

export function downLoad() { // 附件及图片下载
  return request({
    url: cmsServerContext + '/customerUser/download',
    method: 'post'
  })
}

/**
 * 根据客户id查询所有用户
 * @param customerId
 */
export function selectUsersByCustomerId(customerId) {
  return request({
    url: cmsServerContext + '/customerUser/selectUsersByCustomerId/' + customerId,
    method: 'get'
  })
}

/**
 * 查询customer
 * @param customerId
 */
export function selectCustomerById(customerId) {
  return request({
    url: cmsServerContext + '/customerUser/selectCustomerById/' + customerId,
    method: 'get'
  })
}

export function getCustomerInfo(customerId) {
  return request({
    url: cmsServerContext + '/customer/getCustomerInfo/' + customerId,
    method: 'get'
  })
}
export function saveCustomerInfo(customerInfo) {
  return request({
    url: cmsServerContext + '/customer/saveCustomerInfo',
    method: 'post',
    data: customerInfo
  })
}
